var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoPop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#00430B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.146 60.6106C16.5199 52.8872 25.4613 47.832 35.5835 47.832C45.4132 47.832 54.1296 52.5994 59.5464 59.9481C53.2293 66.1637 44.5626 69.9984 35.0003 69.9984C25.7824 69.9984 17.3969 66.435 11.146 60.6106Z",
    fill: "#90F50F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3268 23.8674C46.504 22.2427 46.3624 19.9548 44.9021 18.494C43.3225 16.914 40.7893 16.8693 39.1575 18.3673V18.1586C39.1575 15.8632 37.2948 14 35 14C32.7052 14 30.8425 15.8632 30.8425 18.1586V18.3673C29.2108 16.8768 26.6775 16.914 25.0979 18.494C23.6301 19.9622 23.4886 22.2427 24.6732 23.8674C22.6094 24.1059 21 25.8648 21 27.9963C21 30.2917 22.8627 32.1549 25.1575 32.1549H25.3662L25.1054 32.4158C23.4811 34.0405 23.4811 36.6713 25.1054 38.296C26.6924 39.8834 29.2555 39.9207 30.8797 38.3854C31.148 40.42 32.8914 42 35 42C37.1086 42 38.8521 40.4275 39.1203 38.3854C40.752 39.9132 43.3076 39.8834 44.8946 38.296C46.5189 36.6713 46.5189 34.0405 44.8946 32.4158L44.6339 32.1549H44.8425C47.1373 32.1549 49 30.2917 49 27.9963C48.9925 25.8648 47.3906 24.1059 45.3268 23.8674Z",
    fill: "#90F50F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoPop);
export default __webpack_public_path__ + "static/media/user-logo-pop.cfd2fda3ae4a0eb6f378640f4c5bb5a6.svg";
export { ForwardRef as ReactComponent };